import { clearResult } from "./getPrice";
import { log } from "./logger";
export async function loadAutocomplete(eventtarget, url) {
    log("Triggered load autocomplete");
    var div = jQuery("div[autocomplete-for=" + jQuery(eventtarget).attr("id") + "]");
    let res;
    let controller = new AbortController();
    let timeout = setTimeout(() => controller.abort(), 5000);
    try {
        res = await fetch(url, { signal: controller.signal });
    }
    catch (e) {
        log(e);
        clearTimeout(timeout);
        return;
    }
    res = await res.json();
    clearTimeout(timeout);
    for (let i = 0; i < res.length; i++) {
        if (div.children(`[value="${res[i].name}"]`).length > 0) {
            continue;
        }
        let defaultchild = div.children(".default");
        let newItem = defaultchild.clone(false);
        newItem.attr("value", res[i].name);
        newItem.html(res[i].name);
        if (res[i].code !== undefined) {
            newItem.attr("code", res[i].code);
            newItem.removeClass("hidden");
        }
        newItem.removeClass("default");
        newItem.on("click", (event) => {
            let parent = jQuery(event.target).parent("div[autocomplete-for]");
            let value = String(jQuery(event.target).attr("value"));
            let field = document.getElementById(String(parent.attr("autocomplete-for")));
            if (jQuery(event.target).attr("code") !== undefined) {
                window.ccitycode = Number.parseInt(String(jQuery(event.target).attr("code")));
                //@ts-ignore
                window.ccitycodes[window.mode] = Number.parseInt(String(jQuery(event.target).attr("code")));
            }
            if (field !== null) {
                //@ts-ignore
                field.value = value;
                //@ts-ignore
                window.selectedPlzEntry = value;
                jQuery(field).trigger("select");
            }
            parent.children("div:not(.default)").each((i, el) => {
                jQuery(el).addClass("hidden");
            });
        });
        div.append(newItem);
    }
}
export async function UpdateAutocompleteOptions(event) {
    log("trigger update autocomplete");
    if ((event.key === "Backspace" || event.key === "Delete")) {
        clearResult();
        if (String(jQuery(event.target).val()).length < 4) {
            var autocomplete = jQuery("div[autocomplete-for=" + jQuery(event.target).attr("id") + "]");
            autocomplete.children("div:not(.default)").remove();
        }
    }
    if (String(jQuery(event.target).val()).length >= 4) {
        var autocomplete = jQuery("div[autocomplete-for=" + jQuery(event.target).attr("id") + "]");
        autocomplete.children("div:not(.default)").each((index, element) => {
            log(jQuery(element).attr("value")?.includes(String(jQuery(event.target).val())));
            if (jQuery(element).attr("value")?.toLowerCase().includes(String(jQuery(event.target).val()?.toString().toLowerCase()))) {
                jQuery(element).removeClass("hidden");
            }
            else {
                jQuery(element).addClass("hidden");
            }
        });
        let activeChildren = autocomplete.children("div:not(.hidden)");
        if (activeChildren.length == 1 && !(event.key === "Backspace" || event.key === "Delete")) {
            jQuery(event.target).val(String(jQuery(activeChildren[0]).attr("value"))).trigger("select");
            jQuery(event.target).trigger("blur");
            var parsed = Number.parseInt(String(jQuery(activeChildren[0]).attr("code")));
            if (!Number.isNaN(parsed)) {
                window.ccitycode = parsed;
                //@ts-ignore
                window.ccitycodes[window.mode] = Number.parseInt(String(jQuery(activeChildren[0]).attr("code")));
            }
            jQuery(activeChildren[0]).addClass("hidden");
        }
    }
}
